import React from 'react';
import '../styles/policy.css';

const lastUpdated = '11 de mayo de 2026';

const CookiesPolicy = () => {
  return (
    <div className="policy-page">

      <section className="policy-hero">
        <p className="policy-page-label">LEGAL</p>
        <h1 className="policy-hero-heading fredoka-400">Política de Cookies</h1>
        <p className="policy-hero-sub">Última actualización: {lastUpdated}</p>
      </section>

      <section className="policy-body">
        <div className="policy-content">

          <div className="policy-notice">
            <span className="policy-notice-icon">ℹ</span>
            <p>Este sitio web <strong>no utiliza cookies</strong> para recopilar, almacenar ni rastrear información personal del usuario.</p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-heading">1. ¿Qué son las cookies?</h2>
            <p>Las cookies son pequeños archivos de texto que los sitios web almacenan en el dispositivo del usuario al navegar. Se utilizan habitualmente para recordar preferencias, mantener sesiones activas o recopilar datos de uso con fines analíticos o publicitarios.</p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-heading">2. ¿Usamos cookies en este sitio?</h2>
            <p>No. Este sitio web <strong>no instala ningún tipo de cookie</strong> en el dispositivo del visitante. No utilizamos cookies propias ni de terceros para ningún fin.</p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-heading">3. Tipos de cookies que no usamos</h2>
            <p>A modo informativo, los tipos de cookies que <em>no están presentes</em> en este sitio son:</p>
            <ul className="policy-list">
              <li><strong>Cookies técnicas o de sesión:</strong> no almacenamos sesiones de usuario ni preferencias de navegación.</li>
              <li><strong>Cookies analíticas:</strong> no recopilamos datos sobre el comportamiento o las visitas al sitio.</li>
              <li><strong>Cookies de personalización:</strong> no recordamos preferencias de idioma, región ni ajustes visuales.</li>
              <li><strong>Cookies publicitarias:</strong> no utilizamos redes de publicidad ni seguimiento de intereses.</li>
              <li><strong>Cookies de terceros:</strong> no integramos servicios externos que instalen cookies (Google Analytics, Facebook Pixel, etc.).</li>
            </ul>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-heading">4. Almacenamiento local</h2>
            <p>Este sitio tampoco utiliza tecnologías similares como <em>localStorage</em>, <em>sessionStorage</em> o <em>IndexedDB</em> para almacenar información identificable del usuario.</p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-heading">5. Cambios en esta política</h2>
            <p>Si en el futuro se incorporaran cookies o tecnologías de seguimiento, esta política se actualizará con antelación para informar al usuario de manera transparente sobre su finalidad y cómo gestionarlas.</p>
          </div>

          <div className="policy-section">
            <h2 className="policy-section-heading">6. Contacto</h2>
            <p>Si tienes alguna pregunta sobre esta política, puedes ponerte en contacto con nosotros en:</p>
            <p><a href="mailto:tvcologan@gmail.com" className="policy-link">tvcologan@gmail.com</a></p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default CookiesPolicy;
